import SlideSheet from "components/general/SlideSheet";
import { Box, FormattedCurrency, H4, HStack, Icon, Paragraph, SafeAreaView, Text, Typography, VStack } from "components/ui";
import StocklistStatus from "components/ui/StocklistStatus";
import { Leaf } from "lucide-react-native";
import React from "react";
import { Item } from "store/abcoApi";
import AddToCart from "./AddToCart";
interface Props {
	item: Item;
	isSheetOpen: boolean;
	toggleSheet: () => void;
}
const ItemSlideSheet = ({ item, isSheetOpen, toggleSheet }: Props) => {
	return (
		<SafeAreaView>
			<SlideSheet isSheetOpen={isSheetOpen} toggleSheet={toggleSheet}>
				<VStack gap={12}>
					<Box borderBottomWidth={1} gap={8} borderBottomColor="$neutral100" paddingBottom={12}>
						<Box>
							<H4 sx={{ fontSize: 14, lineHeight: 18 }} weight="bold">
								{item.name ? item.name : "No Item name detected"}
							</H4>
							<Box paddingVertical={4}>
								<StocklistStatus type="required" />
							</Box>
						</Box>
						<FormattedCurrency sx={{ fontSize: "$h4mobile", lineHeight: 23, fontWeight: "bold" }} amount={item.unitPrice} />
					</Box>
					<Box gap={12}>
						<Paragraph>Select quantity</Paragraph>
						<Box p={12} borderRadius={12} borderWidth={1} borderColor="$secondary">
							<HStack justifyContent="space-between" gap={8}>
								<Icon marginTop={4} w={20} aspectRatio={1} as={Leaf} color="$secondary" />
								<Typography sx={{ fontSize: 13 }} weight="normal">
									Update your order to{" "}
									<Text fontWeight="bold" fontSize={13}>
										1 box
									</Text>{" "}
									(12 items). This will reduce packaging resources and the transport footprint.{" "}
									<Text fontWeight="bold" fontSize={13}>
										See more
									</Text>
								</Typography>
							</HStack>
						</Box>
						<HStack gap={8}>
							<Box flex={1} justifyContent="center">
								<AddToCart stockcode={item.stockcode} isPurchaseable={item.isPurchaseable} item={item} />
							</Box>

							{/* <Button flex={1} p={0} onPress={() => toggleSheet()} style={(pressed) => [{ opacity: pressed ? 0.5 : 1 }]}>
								<View w={"$full"} borderRadius={8} bg={"$secondary"} gap={6} paddingHorizontal={16} paddingVertical={8}>
									<Center>
										<Paragraph sx={{ color: "$basicblack" }}>Add to order</Paragraph>
									</Center>
								</View>
							</Button> */}
						</HStack>
					</Box>
				</VStack>
			</SlideSheet>
		</SafeAreaView>
	);
};

export default ItemSlideSheet;
